import { treatmentRecordsActions } from '../../../../actions/user/hospital/Account/treatmentrecords';

const initialState = {
  records: [], // Store records as an array
  selectedRecord: null, // Track currently selected record
  loading: false,
  error: null
};

const hospitalTreatmentReducer = (state = initialState, action) => {
  switch (action.type) {
    // Request actions
    case treatmentRecordsActions.FETCH_TREATMENT_RECORDS.REQUEST:
    case treatmentRecordsActions.FETCH_SINGLE_RECORD.REQUEST:
    case treatmentRecordsActions.CREATE_TREATMENT_RECORD.REQUEST:
    case treatmentRecordsActions.UPDATE_TREATMENT_RECORD.REQUEST:
    case treatmentRecordsActions.DELETE_TREATMENT_RECORD.REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

      // Success actions
    case treatmentRecordsActions.FETCH_TREATMENT_RECORDS.SUCCESS:
      return {
        ...state,
        loading: false,
        records: action.payload, // Store all records
        error: null
      };

    case treatmentRecordsActions.FETCH_SINGLE_RECORD.SUCCESS:
      return {
        ...state,
        loading: false,
        selectedRecord: action.payload, // Store selected record
        error: null
      };

    case treatmentRecordsActions.CREATE_TREATMENT_RECORD.SUCCESS:
      return {
        ...state,
        loading: false,
        records: [...state.records, action.payload], // Add new record to array
        selectedRecord: action.payload, // Set newly created as selected
        error: null
      };

    case treatmentRecordsActions.UPDATE_TREATMENT_RECORD.SUCCESS:
      return {
        ...state,
        loading: false,
        // Replace updated record in the array
        records: state.records.map((record) =>
          record.id === action.payload.id ? action.payload : record
        ),
        selectedRecord: action.payload, // Update selected record
        error: null
      };

    case treatmentRecordsActions.DELETE_TREATMENT_RECORD.SUCCESS:
      return {
        ...state,
        loading: false,
        // Remove deleted record from array
        records: state.records.filter(
          (record) => record.id !== action.payload.id
        ),
        selectedRecord: null, // Clear selected record after deletion
        error: null
      };

      // Failure actions
    case treatmentRecordsActions.FETCH_TREATMENT_RECORDS.FAILURE:
    case treatmentRecordsActions.FETCH_SINGLE_RECORD.FAILURE:
    case treatmentRecordsActions.CREATE_TREATMENT_RECORD.FAILURE:
    case treatmentRecordsActions.UPDATE_TREATMENT_RECORD.FAILURE:
    case treatmentRecordsActions.DELETE_TREATMENT_RECORD.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload // Store error message
      };

      // Reset actions
    case treatmentRecordsActions.FETCH_TREATMENT_RECORDS.RESET:
    case treatmentRecordsActions.FETCH_SINGLE_RECORD.RESET:
    case treatmentRecordsActions.CREATE_TREATMENT_RECORD.RESET:
    case treatmentRecordsActions.UPDATE_TREATMENT_RECORD.RESET:
    case treatmentRecordsActions.DELETE_TREATMENT_RECORD.RESET:
      return {
        ...state,
        error: null,
        loading: false
      };

      // Direct actions for selected record
    case treatmentRecordsActions.SET_SELECTED_RECORD:
      return {
        ...state,
        selectedRecord: action.payload
      };

    case treatmentRecordsActions.CLEAR_SELECTED_RECORD:
      return {
        ...state,
        selectedRecord: null
      };

    default:
      return state;
  }
};

export default hospitalTreatmentReducer;
